import { useEffect } from "react";

/** SP3 §6 — station-level shortcuts: Ctrl+Enter accept, PgUp/PgDn transaction
 *  nav. Pane-internal keys (Tab/Enter field advance) are owned by each pane's
 *  KeyboardManager; these are the transaction-scope gestures. */
export function useStationKeyboard(handlers: { onAccept: () => void; onPrev: () => void; onNext: () => void }): void {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.ctrlKey && e.key === "Enter") { e.preventDefault(); handlers.onAccept(); return; }
      if (e.key === "PageUp") { e.preventDefault(); handlers.onPrev(); return; }
      if (e.key === "PageDown") { e.preventDefault(); handlers.onNext(); return; }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [handlers]);
}
